export type AutomationDryRunTone = 'library' | 'tags' | 'serato' | 'file';

export interface AutomationDryRunOp {
  nodeId: string;
  label: string;
  tone: AutomationDryRunTone;
}

export interface AutomationDryRunFile {
  filePath: string;
  title: string;
  meta: string;
  ops: AutomationDryRunOp[];
}

export interface AutomationDryRunResult {
  files: AutomationDryRunFile[];
  /** Total matches in the watch folder, which may exceed `files.length`. */
  matchCount: number;
  folderPath: string | null;
  /** Set when no projection could be produced (invalid graph, no source files). */
  notice?: string;
}

export const emptyDryRunResult = (): AutomationDryRunResult => ({
  files: [],
  matchCount: 0,
  folderPath: null,
});
